import DocumentDetailInvalid from '@/types/documents/documentDetailInvalid'
import { BaseService } from './../../base'
export class DocumentDetailInvalidService extends BaseService<DocumentDetailInvalid>() {
    static get entity (): string {
        return 'document_detail_invalid'
    }
    static get responseName (): string {
        return 'document_detail_invalid'
    }
}